module.exports = __webpack_public_path__ + "static/media/gig-cross.37e2b4a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Gigs/gig-cross.svg
// module id = 40
// module chunks = 0